import { Navigate, Route, Routes } from 'react-router-dom';
import AffiliateLogin from './Auth/AffiliateLogin';
import Dashboard from './Dashboard';
import NotificationsAdmin from './Notifications/index';
import AffiliateProfile from './Profile/AffiliateProfile';
import ChangePassword from './Profile/ChangePassword';
import EditProfile from './Profile/EditProfile';

const AffiliateRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="notifications" element={<NotificationsAdmin />} />
      <Route path="profile" element={<AffiliateProfile />} /> 
      <Route path="profile/edit-profile" element={<EditProfile />} /> 
      <Route path="profile/change-password" element={<ChangePassword />} /> 
      <Route path="*" element={<Navigate to="/affiliate/dashboard" />} />
    </Routes>
  );
};

export default AffiliateRoutes;

export {
  AffiliateLogin,
  Dashboard
};

